import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule, DictionaryFieldsModule, MasterDetailModule, NumberInputModule, ServiceResponseModule } from '@sdbn/common';
import { ErpCommonModule } from './../erp-common/erp-common.module';
import { CatalogRoutingModule } from './catalog-routing.module';
import { CostspriceListComponent } from './components/article-editor/costsprice-list/costsprice-list.component';
import { CatalogAdminComponent } from './components/catalog-admin/catalog-admin.component';
import { CatalogMasterdataComponent } from './components/catalog-masterdata/catalog-masterdata.component';

import { ReactiveFormsModule } from '@angular/forms';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { CommonDateModule, CUSTOM_DATE_FORMAT, DictionaryModule, TmcCustomDateAdapter } from '@sdbn/common';
import { AddArticleTypeSelectionComponent } from './components/add-article-type-selection/add-article-type-selection.component';
import { AddCatalogDialogComponent } from './components/add-catalog-dialog/add-catalog-dialog.component';
import { AddCatalogNodeDialogComponent } from './components/add-catalog-node-dialog/add-catalog-node-dialog.component';
import { ArticleEditorComponent } from './components/article-editor/article-editor.component';
import { DescriptionEditorComponent } from './components/article-editor/description-editor/description-editor.component';
import { PriceEditorComponent } from './components/article-editor/price-editor/price-editor.component';
import { RetailpriceBasicarticleListComponent } from './components/article-editor/retailprice-basicarticle-list/retailprice-basicarticle-list.component';
import { RetailpriceListComponent } from './components/article-editor/retailprice-list/retailprice-list.component';
import { CatalogArticleSearchComponent } from './components/catalog-article-search/catalog-article-search.component';
import { CatalogStructureComponent } from './components/catalog-structure/catalog-structure.component';
import { ChangeCatalogDialogComponent } from './components/change-catalog-dialog/change-catalog-dialog.component';
import { ChangeCatalogNodeDialogComponent } from './components/change-catalog-node-dialog.component.ts/change-catalog-node-dialog.component';
import { importCostsPricesDialogComponent } from './components/import-costsprice-dialog/import-costsprice-dialog.component';
import { AttributeValuePipe } from './pipe/attribute-value.pipe';


@NgModule({
  declarations: [
    CatalogAdminComponent,
    CatalogMasterdataComponent,
    CatalogStructureComponent,
    ArticleEditorComponent,
    DescriptionEditorComponent,
    PriceEditorComponent,
    AddCatalogDialogComponent,
    AddCatalogNodeDialogComponent,
    AddArticleTypeSelectionComponent,
    ChangeCatalogDialogComponent,
    ChangeCatalogNodeDialogComponent,
    CatalogArticleSearchComponent,
    RetailpriceListComponent,
    RetailpriceBasicarticleListComponent,
    CostspriceListComponent,
    importCostsPricesDialogComponent,
    AttributeValuePipe
  ],
  imports: [
    CommonModule,
    CatalogRoutingModule,
    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule,

    ReactiveFormsModule,
    DictionaryModule,
    CommonDateModule,
    NumberInputModule,
    ErpCommonModule,
    ServiceResponseModule,
    MasterDetailModule,
    DictionaryFieldsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatTableModule,
    MatIconModule,
    MatSortModule,
    MatSelectModule,
    MatRadioModule
  ],
  providers: [
    { provide: DateAdapter, useClass: TmcCustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'de' }
  ]
})
export class CatalogModule { }
